<div class="d-flex flex-column justify-content-center gap-1">
  <div class="d-flex justify-content-end" >
    <img class="cursor-pointer" [src]="'assets/svg-icons/close.svg'" alt="" (click)="dialogRef.close()"/>
  </div>
  <div class="d-flex flex-column gap-3 ps-4 pe-4 mb-3">
    <span class="title text-center">{{title}}</span>
    <textarea class="input input-text-area" cdkTextareaAutosize
              [cdkAutosizeMinRows]="6"
              placeholder="{{placeholder}}"
              [(ngModel)]="note">{{note}}
    </textarea>
    <div class="d-flex flex-row w-100 justify-content-between button-container-private">
      <button class="menu-button" (click)="dialogRef.close()">{{optionCancel}}</button>
      <button class="menu-button save-button" [mat-dialog-close]="true" (click)="savePrivateNote()">{{optionSave}}</button>
    </div>
  </div>
</div>

